import {State} from '../../reducers'
import { Link } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { BasicLayout } from '../../modules/Layouts/basicLayout'
import FormularioBuscarLibros from './Components/LibroVentasConsulta/FormularioBuscarLibros'
import TableLibros from './Components/LibroVentasConsulta/TableLibros'

const LibroVentasConsulta = () => {
  const {dataConsultaLibros} = useSelector((state: State) => state.libros)

  return (
    <BasicLayout>
      <div className='header-link'>
        <Link to={'/mas-opciones/libro-ventas'} className='back-button w-inline-block'></Link>
        <h3 className='h3-titles xl'>Historial de Libro de IVA para Ventas</h3>
      </div>
      <div className='separador'></div>
      <div className='w-layout-layout bill-section wf-layout-layout'>
        <div id='w-node-_5c6af4dc-0d52-341f-2ef6-a52695e59ed4-0b1e6fa6' className='w-layout-cell'>
          <div className='card' style={{height: 'auto'}}>
            <div className='w-layout-vflex card-content'>
              <FormularioBuscarLibros />
            </div>
          </div>
          {
            dataConsultaLibros?.length > 0 && 
            (
            <div className='card' style={{height: 'auto', marginTop: '20px'}}>
              <div className='w-layout-vflex card-content'>
                <TableLibros />
              </div>
            </div>
            )
          }
        </div>
      </div>
    </BasicLayout>
  )
}

export default LibroVentasConsulta
